export class PresetModel{
  id:number;
  header:string;
  content:string;
  isSelected:boolean;
}
